import React from 'react';
import Table from './Table';


const Items = ({ items }) => (
    <div className="row">
        <div className="col">
            <div className="card shadow mb-5">
                <div className="card-header border-0">
                    <h3 className="mb-0">Itens da Venda</h3>
                </div>
                <div className="table-responsive">
                    <Table items={items} />
                </div>
            </div>
        </div>
    </div>
);

export default Items;


// WEBPACK FOOTER //
// ./src/components/Pages/Orders/Details/Items/index.js